<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import translate from "i18n-jsautotranslate";
export default {
  mounted() {
    this.$nextTick(() => {
      translate.execute();
      setTimeout(function () {
        translate.execute();
      }, 500);
    });
  },
};
</script>
<style></style>
